import { createFileRoute } from '@tanstack/react-router';

import {
  type WgAdminTab,
  AdminWhiteGloveView,
} from 'src/sections/admin/white-glove/admin-white-glove-view';

/**
 * `tab` is in the URL rather than in state alone so a link can land on the one
 * that answers the question being asked -- a breach on the overview hands its
 * brand to the engagement list, and the metrics screen goes back to the list it
 * was opened from rather than to the program numbers.
 */
export const Route = createFileRoute('/admin-skidog/white-glove/')({
  validateSearch: (search: Record<string, unknown>): { tab: WgAdminTab; brand?: string } => ({
    tab: search.tab === 'engagements' ? 'engagements' : 'overview',
    brand: typeof search.brand === 'string' && search.brand ? search.brand : undefined,
  }),
  component: AdminWhiteGlovePage,
});

function AdminWhiteGlovePage() {
  const { tab, brand } = Route.useSearch();
  return <AdminWhiteGloveView initialTab={tab} initialBrand={brand ?? ''} />;
}
